/* unplugin-vue-components disabled */import script from "./WOQualifications.vue?vue&type=script&setup=true&lang=js"
export * from "./WOQualifications.vue?vue&type=script&setup=true&lang=js"

import "./WOQualifications.vue?vue&type=style&index=0&id=6a7f9f54&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7f9f54"]])

export default __exports__